/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'update';
const componentName = 'progress-note';
const prefix = `${moduleName}.${componentName}`;

export const progressMessage = `${prefix}.progressMessage`;

export const ENGLISH = {
    [progressMessage]: 'This may take a couple of minutes. You may close the wizard and continue working. To check on progress you can re-access from \'In progress\' tile or upon completion from \'Recent\' tiles on the right.',
};
